import StarIcon from './assets/service-icon-1.svg'
import TradeIn from './assets/service-icon-2.svg'
import Award from './assets/service-icon-3.svg'
import Card from './assets/service-icon-4.svg'
import Service from './assets/service-icon-5.svg'
import Document from './assets/service-icon-6.svg'

export const data = [
	{
		text: 'Оплата бонусами',
		link: `/personal/bonuses`,
		icon: StarIcon,
		ariaLabel: 'Войти в личный кабинет',
		authorizedField: {
			text: 'Получай бонусы',
			ariaLabel: 'Перейти в личный кабинет'
		}
	},
	{
		text: 'Обмен в Трейд-ин',
		link: `/services/trade-in/`,
		icon: TradeIn,
		ariaLabel: 'Страница Обмен в Трейд-ин'
	},
	{
		text: 'Гарантия качества',
		link: '/guarantee/',
		icon: Award,
		ariaLabel: 'Страница с информацией о гарантии'
	},
	{
		text: 'Карта преимуществ iPort+',
		link: '/services/plus/',
		icon: Card,
		ariaLabel: 'Карта iPort+'
	},
	{
		text: 'Страхование устройств',
		link: '/services/insurance/',
		icon: Service,
		ariaLabel: 'Страхование устройств'
	},
	{
		text: 'Рассрочка и кредит',
		link: '/services/credit/',
		icon: Document,
		ariaLabel: 'Рассрочка и кредит'
	}
]
